let ScrollMagic;
if (typeof document !== 'undefined') {
  ScrollMagic = require('scrollmagic');
  require('imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap');
}

export default ScrollMagic;



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/importers/ScrollMagic.js